import { useSetSearchParams } from '@hook/useSetSearchParams';
import { fetchData } from '@network/querys';
import type React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface ICheckbox {
    watch: string;
    cls: string;
    title: string;
    path: string;
    resetObj: Record<string, string>;
    ga360str: string;
    activeChecked: string | null;
    submitCallback?: (_d: string) => void;
}

export const Checkbox = ({ props }: { props: ICheckbox }) => {
    const { watch, cls, title, path, submitCallback, resetObj, ga360str, activeChecked } = props;
    const setParams = useSetSearchParams();
    const articleRef = useRef<HTMLElement>(null);
    const [dat, datSet] = useState<Array<{ id: string; name: string }>>([]);
    const [checkItems, setCheckItems] = useState<string[]>([]);
    const { t } = useTranslation();

    useEffect(() => {
        fetchData(path).then((res: Array<{ id: string; name: string }>) => {
            res.unshift({ id: '', name: t('common.all') });
            datSet(res.map((it) => ({ id: it.id.toString(), name: it.name })));
        });
    }, [path, t]);

    useEffect(() => {
        setCheckItems(!activeChecked ? [''] : activeChecked.split(','));
    }, [activeChecked]);

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const el = e.target;
        let result = '';
        let uniqueArr: string[] = [];

        if (el.value === '' && el.checked) result = '';

        if (el.value !== '') {
            if (el.checked) {
                if (!articleRef.current) return;
                const datarr: string[] = [...checkItems, el.value];
                uniqueArr = datarr.filter((it, idx) => {
                    if (it === '') return false;
                    return datarr.indexOf(it) === idx;
                });
            } else {
                uniqueArr = checkItems.filter((it) => it !== el.value);
            }
            result = uniqueArr.join(',');
        }
        setParams({ [watch]: result, ...resetObj });
        submitCallback?.(result);
    };

    return (
        <section className={cls}>
            <header>{title}</header>
            <article className="checkbox-wrapper" data-areas={ga360str} ref={articleRef}>
                {dat.map((it, idx) => (
                    <span className="checkbox" key={cls + idx + it.id}>
                        <input
                            type="checkbox"
                            id={`${watch}_checkbox_${it.id}`}
                            name={`${watch}_checkbox_${it.id}`}
                            value={it.id}
                            checked={checkItems.includes(it.id)}
                            onChange={onChange}
                        />
                        <label htmlFor={`${watch}_checkbox_${it.id}`} data-areas={ga360str}>
                            {it.name}
                        </label>
                    </span>
                ))}
            </article>
        </section>
    );
};
